import React, { useEffect } from "react";
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import { api } from "common";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import moment from "moment/min/moment-with-locales";
import { withFallbackTranslations } from "common/src/other/fallbackTranslations";

function AuthLoading(props) {
  const { t } = useTranslation();
  const {
    fetchUser,
    fetchCarTypes,
    fetchSettings,
    fetchBookings,
    fetchCancelReasons,
    fetchPromos,
    fetchUsers,
    fetchNotifications,
    signOff,
    fetchWithdraws,
    fetchPaymentMethods,
    fetchLanguages,
    fetchWalletHistory,
    fetchCars,
    fetchComplain,
    fetchSMTP,
    fetchSos,
    fetchSMSConfig,
    fetchZonificacionCities,
    fetchLeaderAlerts,
    fetchLeaderWeeklyHistory,
    fetchDeepseekApiKey,
    fetchGeminiApiKey,
  } = api;
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const languagedata = useSelector((state) => state.languagedata);
  const settingsdata = useSelector((state) => state.settingsdata);

  useEffect(() => {
    dispatch(fetchSettings());
  }, [dispatch, fetchSettings]);

  useEffect(() => {
    let obj = {};
    let def1 = {};
    if (languagedata.langlist) {
      for (const value of Object.values(languagedata.langlist)) {
        obj[value.langLocale] = withFallbackTranslations(value.langLocale, value.keyValuePairs);
        if (value.default === true) {
          def1 = value;
        }
      }
      if(def1 && def1.langLocale){
        const result = localStorage.getItem('lang');
        let saved = null;
        try {
          saved = result ? JSON.parse(result) : null;
        } catch (e) {
          saved = null;
        }
        if (saved && saved.langLocale && obj[saved.langLocale]) {
          i18n.addResourceBundle(
            saved.langLocale,
            "translations",
            obj[saved.langLocale]
          );
          i18n.changeLanguage(saved.langLocale);
          moment.locale(saved.dateLocale || saved.langLocale);
        } else {
          i18n.addResourceBundle(
            def1.langLocale,
            "translations",
            obj[def1.langLocale]
          );
          i18n.changeLanguage(def1.langLocale);
          moment.locale(def1.dateLocale);
        }
      }

      dispatch(fetchUser());
    }
  }, [languagedata, dispatch, fetchUser]);

  useEffect(() => {
    if (settingsdata.settings) {
      dispatch(fetchLanguages());
      dispatch(fetchCarTypes());
      dispatch(fetchZonificacionCities());
      document.title = settingsdata.settings.appName;
    }
  }, [settingsdata.settings, dispatch, fetchLanguages, fetchCarTypes, fetchZonificacionCities]);

  useEffect(() => {
    if (auth.profile) {
      if (auth.profile.usertype) {
        let role = auth.profile.usertype;
        if (role === "customer") {
          dispatch(fetchBookings());
          dispatch(fetchWalletHistory());
          dispatch(fetchPaymentMethods());
          dispatch(fetchCancelReasons());
        } else if (role === "driver") {
          dispatch(fetchBookings());
          dispatch(fetchPaymentMethods());
          dispatch(fetchCars());
          dispatch(fetchWalletHistory());
        } else if (role === "admin") {
          dispatch(fetchUsers());
          dispatch(fetchBookings());
          dispatch(fetchPromos());
          dispatch(fetchNotifications());
          dispatch(fetchCancelReasons());
          dispatch(fetchWithdraws());
          dispatch(fetchComplain());
          dispatch(fetchPaymentMethods());
          dispatch(fetchCars());
          dispatch(fetchSMTP());
          dispatch(fetchSMSConfig());
          dispatch(fetchSos());
          dispatch(fetchLeaderAlerts());
          if (fetchLeaderWeeklyHistory) dispatch(fetchLeaderWeeklyHistory());
          if (fetchDeepseekApiKey) dispatch(fetchDeepseekApiKey());
          else if (fetchGeminiApiKey) dispatch(fetchGeminiApiKey());
        } else if (role === "fleetadmin") {
          dispatch(fetchUsers());
          dispatch(fetchBookings());
          dispatch(fetchCars());
          dispatch(fetchCancelReasons());
          dispatch(fetchPaymentMethods());
          dispatch(fetchWalletHistory());
        } else {
          alert(t("not_valid_user_type"));
          dispatch(signOff());
        }
      } else {
        alert(t("user_issue_contact_admin"));
        dispatch(signOff());
      }
    }
  }, [
    auth.profile,
    dispatch,
    fetchBookings,
    fetchCancelReasons,
    fetchNotifications,
    fetchPromos,
    fetchUsers,
    fetchWithdraws,
    signOff,
    fetchPaymentMethods,
    fetchWalletHistory,
    fetchCars,
    fetchComplain,
    fetchSMTP,
    fetchSMSConfig,
    fetchSos,
    fetchLeaderAlerts,
    fetchLeaderWeeklyHistory,
    fetchDeepseekApiKey,
    fetchGeminiApiKey,
    t
  ]);

  // Reset password: no bloquear por settings/idioma (el enlace llega directo a /auth/action).
  const isAuthAction =
    typeof window !== 'undefined' &&
    window.location &&
    String(window.location.pathname || '').startsWith('/auth/action');
  if (isAuthAction) {
    return props.children;
  }

  return settingsdata.loading ? (
    <CircularLoading />
  ) : settingsdata.settings ? (
    auth.loading || !languagedata.langlist ? (
      <CircularLoading />
    ) : (
      props.children
    )
  ) : (
    <div>
      <span>{t('settings_not_found')}</span>
  </div>
  );
}

export default AuthLoading;
